import { useState, useCallback } from 'react';

export default function useTilt() {
  const [tilt, setTilt] = useState({ x: 0, y: 0, shine: { x: 50, y: 50 } });

  const onMouseMove = useCallback((e) => {
    const card = e.currentTarget;
    const box = card.getBoundingClientRect();
    const x = e.clientX - box.left;
    const y = e.clientY - box.top;
    
    // Calculate tilt (max 15 degrees)
    const centerX = box.width / 2;
    const centerY = box.height / 2;
    const tiltX = (y - centerY) / 15;
    const tiltY = (centerX - x) / 15;

    // Calculate shine position (0-100%)
    const shineX = (x / box.width) * 100;
    const shineY = (y / box.height) * 100;

    setTilt({ x: tiltX, y: tiltY, shine: { x: shineX, y: shineY } });
  }, []);

  const onMouseLeave = useCallback(() => {
    setTilt({ x: 0, y: 0, shine: { x: 50, y: 50 } });
  }, []);

  return { tilt, onMouseMove, onMouseLeave };
}
